import React from 'react';
import { Link, useParams } from 'react-router-dom';

export default function NotFound() {
  const { lang = 'ar' } = useParams();
  return (
    <section className="section-pad">
      <div className="container-zt" style={{ textAlign: 'center' }}>
        <div className="font-display" style={{ fontSize: 96, lineHeight: 1 }}>404</div>
        <p style={{ marginTop: 12, color: 'var(--stone)' }}>{lang === 'ar' ? 'Página no encontrada.' : 'Page not found.'}</p>
        <Link to={`/${lang}`} className="btn btn-primary" style={{ marginTop: 24 }}>
          {lang === 'ar' ? 'Volver al inicio' : 'Back home'}
        </Link>
      </div>
    </section>
  );
}
